
import React from 'react'

import {useFechInitManagemenets} from './hooks'
import { useLocation, useParams } from 'react-router-dom';
import { AllowedAccess } from 'react-permission-role';
import { Button, Card, CardContent, Grid } from '@mui/material';
import { LinearLoading } from 'common';
import { Plus } from 'react-feather';
import { ManagementsTable } from './ManagementsTable/ManagementsTable';
export const LegalVehiclesManagements = () => {


    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFechInitManagemenets({location, paramsURL})

    const {

        globalStates,

        FetchData,

        //------------- Actions
        Actions
    } = useFetchInit

    const {handleClickNewManagement} = Actions

    return (
        <AllowedAccess permissions={['121_VEHICULOS_GESTIONES']} renderAuthFailed={<p>Error</p>}>
            <div className='content'>
                <>
                    <div className='panel-body' id='listadoregistros'>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Card style={{zIndex:'1'}}>
                                    <CardContent>
                                        <div className='h4 mt-1 mb-1'> Otras Gestiones</div>
                                        <div className="border-bottom border-dark"></div>
                                        {/* {loadingFetchLeaseApplications && ( <LinearLoading /> )} */}

                                        <Button
                                            startIcon={<Plus/>}
                                            size='medium'
                                            type='button'
                                            variant='contained' 
                                            color='primary' 
                                            sx={{marginTop: 4}}
                                            onClick={() => handleClickNewManagement()}
                                        >
                                            Nueva Gestion
                                        </Button>
                                        
                                        
                                        <div className="pt-4"></div>
                                            <ManagementsTable 
                                                useFetchInit={useFetchInit}
                                            />
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                </>
            </div>
        </AllowedAccess>
    )
}
